/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/forbid-prop-types */
import React, { forwardRef } from 'react';
import { noop as _noop } from 'lodash';
import { withTranslation } from 'react-i18next';
import { SecondaryAction } from '~/pistonSalsita';

import withIntegration from '../containers/withIntegration';

const NavDropdown = (
  {
    open = false,
    children,
    onClick = _noop,
    label,
    integration,
    categoryDropdownRef,
    id,
    // Goes on the wrapper, so a caller can style its own menu without
    // reaching into the shared ul.dropdown-menu rules.
    className = '',
  },
  dropdownWrapper,
) =>
  React.createElement(
    integration ? 'div' : 'li',
    {
      className: `dropdown ${className} ${open ? 'open' : ''}`,
      ref: dropdownWrapper,
    },
    <>
      {integration ? (
        <SecondaryAction label={label} onClick={onClick} />
      ) : (
        <a
          id={id}
          role="button"
          className="dropdown-toggle"
          aria-haspopup="true"
          tabIndex={0}
          aria-expanded={open.toString()}
          onClick={onClick}
          // The toggle is focusable but is not a real button, so Enter and
          // Space have to be wired up by hand to open the menu.
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onClick(event);
            }
          }}
        >
          {label}
        </a>
      )}
      <ul
        role="menu"
        className="dropdown-menu"
        aria-labelledby={id}
        ref={categoryDropdownRef}
      >
        {children}
      </ul>
    </>,
  );

export default withIntegration(
  withTranslation('translation', { withRef: true })(forwardRef(NavDropdown)),
);
